import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isList?: boolean;
  color: string;
}> = ({ isList, color }) => ({
  overflow: 'hidden',
});

export const name: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
};

export const nameTool: SxStyle = {
  fontSize: (p) => p.typography.pxToRem(10),
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const desTool: SxStyle = {
  fontSize: (p) => p.typography.pxToRem(10),
};

export const labelContainer: SxStyleFunc<{
  isTable?: boolean;
  showViewAll?: boolean;
}> = ({ isTable, showViewAll }) =>
  isTable
    ? {
        maxWidth: showViewAll ? '100px' : '180px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
      }
    : {};

export const labelName: SxStyleFunc<{
  isTable?: boolean;
  showViewAll?: boolean;
  color: string;
}> = ({ isTable, showViewAll, color }) =>
  isTable
    ? {
        color,
        ...name,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }
    : {
        color,
        ...name,
      };
